var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.embedded ? 'embedded' : '',attrs:{"id":"layout"}},[(_vm.ready)?_c('Alerts'):_vm._e(),(_vm.ready)?_c('Views'):_vm._e(),(_vm.ready)?_c('Footer'):_vm._e(),_c('LoadingIndicator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }